import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, PRICE } from '../data/product';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const targets = ['top', 'offer', 'final'].map(id => document.getElementById(id)).filter((el): el is HTMLElement => el !== null);
    const inView = new Set<string>();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) inView.add(entry.target.id);else inView.delete(entry.target.id);
      });
      setVisible(inView.size === 0);
    });
    targets.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-night px-4 py-3 transition-transform duration-200 ease-out motion-reduce:transition-none md:hidden ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} data-id="element-215" data-mp="3klhhrw9af1wl">
      <div className="flex items-center justify-between gap-3" data-id="element-216" data-mp="76f82ocbb3l5">
        <div data-id="element-217" data-mp="27kgoy0a46pf">
          <p className="font-display text-xl font-extrabold leading-none text-cream" data-id="element-218" data-mp="27u7gnt5ehw6">{PRICE}</p>
          <p className="mt-1 text-[11px] text-muted" data-id="element-219" data-mp="gwqovbh3h79g">Instant digital access</p>
        </div>
        <a href={CHECKOUT_URL} tabIndex={visible ? 0 : -1} className="inline-flex h-12 items-center whitespace-nowrap rounded-xl bg-pumpkin px-5 font-display text-sm font-extrabold uppercase tracking-wide text-ink transition-[background-color,transform] duration-150 ease-out active:scale-[0.98]" data-id="element-220" data-mp="c4p38yy1e46r">
          Get It Now
        </a>
      </div>
    </div>;
}